import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FilterIcon, LogOutIcon, ClockIcon, MessageSquareOffIcon } from 'lucide-react';
export function WhatsInsideSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 sm:py-32" style={{
    backgroundColor: '#0a0a0f'
  }} data-id="element-183">
      <div className="max-w-5xl mx-auto px-5 sm:px-8" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center mb-16" data-id="element-185">
          <p className="text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{
          color: '#f97316'
        }} data-id="element-186">
            What's Inside
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-187">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1,
          ease: 'easeOut'
        }} className="rounded-xl p-8 backdrop-blur-sm" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderTop: '2px solid #f97316'
        }} data-id="element-188">
            <FilterIcon className="w-8 h-8 mb-5" style={{
            color: '#f97316'
          }} aria-hidden="true" data-id="element-189" />
            <h3 className="text-lg font-bold text-white mb-2" data-id="element-190">
              The Pre-Meeting Filter
            </h3>
            <p className="leading-relaxed" style={{
            color: '#a1a1aa'
          }} data-id="element-191">
              One sentence that cancels 50% of your invites before they start.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2,
          ease: 'easeOut'
        }} className="rounded-xl p-8 backdrop-blur-sm" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderTop: '2px solid #f97316'
        }} data-id="element-192">
            <LogOutIcon className="w-8 h-8 mb-5" style={{
            color: '#f97316'
          }} aria-hidden="true" data-id="element-193" />
            <h3 className="text-lg font-bold text-white mb-2" data-id="element-194">
              The Agenda-Less Exit
            </h3>
            <p className="leading-relaxed" style={{
            color: '#a1a1aa'
          }} data-id="element-195">
              How to jump off a call when it hits "diminishing returns" while
              looking like a high-performer.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.3,
          ease: 'easeOut'
        }} className="rounded-xl p-8 backdrop-blur-sm" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderTop: '2px solid #f97316'
        }} data-id="element-196">
            <ClockIcon className="w-8 h-8 mb-5" style={{
            color: '#f97316'
          }} aria-hidden="true" data-id="element-197" />
            <h3 className="text-lg font-bold text-white mb-2" data-id="element-198">
              The "Hard Stop" Frame
            </h3>
            <p className="leading-relaxed" style={{
            color: '#a1a1aa'
          }} data-id="element-199">
              How to train your colleagues to respect your time in 48 hours.
            </p>
          </motion.div>

          {/* Card 4 */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.4,
          ease: 'easeOut'
        }} className="rounded-xl p-8 backdrop-blur-sm" style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderTop: '2px solid #f97316'
        }} data-id="element-200">
            <MessageSquareOffIcon className="w-8 h-8 mb-5" style={{
            color: '#f97316'
          }} aria-hidden="true" data-id="element-201" />
            <h3 className="text-lg font-bold text-white mb-2" data-id="element-202">
              The Slack/Teams Ghosting Guide
            </h3>
            <p className="leading-relaxed" style={{
            color: '#a1a1aa'
          }} data-id="element-203">
              How to handle the "Quick Sync" DM without opening the Zoom link.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}